import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { Group } from '../../domain/group';
import { useAuthentication } from '../../modules/auth/AuthenticationProvider';
import { BACKEND_URL } from '../backend-url';

export const useGroupsRepository = () => {
    const { getJwtToken } = useAuthentication();

    const query = useQuery({
        queryKey: ['groups'],
        placeholderData: keepPreviousData,
        staleTime: 15 * 60 * 1000, // 15 minutes
        queryFn: async () => {
            const token = await getJwtToken();

            const response = await fetch(`${BACKEND_URL}/groups`, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (!response.ok) {
                throw new Error('Failed to fetch groups');
            }

            return await response.json() as Array<Group>;
        },
    });

    return {
        ...query,
    };
};
